import Axios from "axios";
import config from "../app.config";

export var dashBoardService;
export default dashBoardService = {
    getDataDashBoard,
    getListTypeDashBoard,
    getListUserDashBoard,
}

async function getDataDashBoard(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/getDataDashBoard`,{params : data})
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}
async function getListTypeDashBoard(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/getListTypeDashBoard`)
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}
async function getListUserDashBoard(data) {
  return await Axios.get(`${config.LOCAL_API_URL}/getListUserDashBoard`,{params : data})
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    })
}